const { VITE_PRODUCT_AI_NAME, VITE_PRODUCT_NAME, VITE_PRODUCT_ALL_NAME } = import.meta.env;

export const PRODUCT_AI_TITLE = VITE_PRODUCT_AI_NAME;
export const PRODUCT_AI_TITLE_BUILDIN = '空间 AI 查询额度';
export const PRODUCT_AI_PAY_TITLE = 'AI 包月权益';
export const PRODUCT_NAME = VITE_PRODUCT_NAME;
export const PRODUCT_ALL_NAME = VITE_PRODUCT_ALL_NAME;
